import React, { useEffect } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import SlideOne from '../components/landing/slideOne';
import SlideProblemOs from '../components/landing/slideProblemOs';
import SlideTwo from '../components/landing/slideTwo';
import SlideThree from '../components/landing/slideThree';
import SlideWhatsNew from '../components/landing/slideWhatsNew';
import SlideFour from '../components/landing/slideFour';
import SlideFive from '../components/landing/slideFive';
import SlideSix from '../components/landing/slideSix';
import SlideCourseIdeas from '../components/landing/slideCourseIdeas';
import { preloadPolicies } from '../utils/policies';

/** Platform marketing site (coursolo.ai / localhost). */
const MarketingLanding = () => {
    const isLoggedIn = sessionStorage.getItem('uid') !== null;

    useEffect(() => {
        preloadPolicies();
    }, []);

    return (
        <>
            <Header isHome={isLoggedIn} />
            <SlideOne />
            <SlideProblemOs />
            <SlideTwo />
            <SlideThree />
            <SlideWhatsNew />
            <SlideCourseIdeas />
            <SlideFour />
            <SlideFive />
            <SlideSix />
            <Footers />
        </>
    );
};

export default MarketingLanding;
